import { TDirectoryItem } from 'src/store/directories/types';

export const checkIsRegularDirectories = (directory: unknown): directory is TDirectoryItem[] => {
  return Array.isArray(directory) && directory.every((dirValue) => checkIsRegularDirectory(dirValue));
};

export const checkIsRegularDirectory = (directory: unknown): directory is TDirectoryItem => {
  return !!directory && typeof directory === 'object' && 'data' in directory && 'id' in directory;
};
